import React from 'react';
import { useDispatch } from 'react-redux';
import { fetchTimelineData } from '@store/timeline/data/actions';
import Timeline from '@components/session-timeline';

import TimelinePageStyled from './styled';

interface TimelineProps {
  isSharing: boolean;
  pageType: number;
  match: {
    params: { id: string };
  };
}

const TimelinePage = ({
  match,
  pageType,
  isSharing = false,
}: TimelineProps) => {
  const {
    params: { id },
  } = match;
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(fetchTimelineData(pageType));
  }, [id, dispatch]);

  return (
    <TimelinePageStyled>
      <Timeline isSharing={isSharing} id={id} pageType={pageType} />
    </TimelinePageStyled>
  );
};

export default TimelinePage;
